import { types, getEnv } from 'mobx-state-tree';


const MODEL_NAME = 'AccountModalModel';

const AccountModalModel = types
    .model(MODEL_NAME, {
        isOpen: false,
    })
    .volatile(() => ({
        options: {},
    }))
    .views(self => ({
        get context() {
            return getEnv(self);
        },
        get viewStore() {
            return self.context.viewStore;
        },
        get startupOptions() {
            return {
                startPage: self.options.startPage || null,
                magicLinkToken: self.options.magicLinkToken || null,
                onSignup: self.options.onSignup || null,
            };
        },
    }))
    .actions(self => ({
        open(options = {
            acceptCallback: null,
            startPage: null,  // Page that the account modal should start on
            magicLinkToken: null,  // Magic link needed by Register with Link Screen
            onSignup: null, // Function to run when the sign up is successful
        }) {
            self.isOpen = true;
            self.options = options;
        },
        close() {
            self.isOpen = false;
            self.options = null;
        },
        accept() {
            if (typeof self.options.acceptCallback === 'function') {
                self.options.acceptCallback();
            }
            self.close();
        },
        reject() {
            self.close();
        },
    }));

function createAccountModalModel(context){
    return AccountModalModel.create({}, context);
}

export {
    AccountModalModel,
    createAccountModalModel,
    MODEL_NAME,
};
